import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ISegment } from '../../../sessions/segments.service';

@Component({
  selector: 'segment-select',
  templateUrl: './segment-select.component.html',
  styleUrls: ['./segment-select.component.scss']
})
export class SegmentSelectComponent {
  @Input() segments: ISegment[] = [];
  @Input() segmentId: number = null;
  @Output() selectSegmentId = new EventEmitter<number>();

  constructor(private translateService: TranslateService) {}

  public select(segment: ISegment) {
    const id = +segment.segment_id;
    this.segmentId = id;
    this.selectSegmentId.emit(id);
  }

  public formatDate(date: string): string {
    if (!date) return '-';
    const lang = this.translateService.store.currentLang || this.translateService.store.defaultLang;
    return lang.toLowerCase().substring(0, 2) === 'fr'
      ? moment(date).format('DD/MM/YYYY HH:mm')
      : moment(date).format('MM/DD/YYYY, hh:mm A');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/segments/segment-select/segment-select.component.ts